import React from 'react';
import { Image, Platform, StyleSheet, Text, TouchableOpacity, View, ViewStyle } from 'react-native';
import { useTranslation } from '@/hooks/useTranslation';
import { typography } from '@/styles/tokens';

interface GoogleSignInButtonProps {
  onPress: () => void;
  disabled?: boolean;
  style?: ViewStyle;
}

const webDataAttrs = Platform.OS === 'web'
  ? ({ dataSet: { authButton: 'google' } } as unknown as { [key: string]: unknown })
  : {};

const webLabelAttrs = Platform.OS === 'web'
  ? ({ dataSet: { authButtonLabel: 'true' } } as unknown as { [key: string]: unknown })
  : {};

export function GoogleSignInButton({ onPress, disabled, style }: GoogleSignInButtonProps) {
  const { t } = useTranslation();

  if (Platform.OS !== 'ios' && Platform.OS !== 'android' && Platform.OS !== 'web') {
    return null;
  }

  return (
    <TouchableOpacity
      {...webDataAttrs}
      style={[styles.button, style]}
      onPress={onPress}
      disabled={disabled}
      activeOpacity={0.85}
    >
      <View style={styles.inner} pointerEvents="none">
        <Image
          source={{ uri: 'https://developers.google.com/identity/images/g-logo.png' }}
          style={styles.icon}
        />
        <Text {...webLabelAttrs} style={styles.label}>{t('otp.continueWithGoogle')}</Text>
      </View>
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  button: {
    backgroundColor: '#FFFFFF',
    borderRadius: 11,
    paddingVertical: 14,
    paddingHorizontal: 18,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 0,
    borderWidth: 1,
    borderColor: '#C4C7C5',
    gap: 10,
    ...Platform.select({
      web: {
        boxShadow: '0 1px 2px rgba(0, 0, 0, 0.4)',
        isolation: 'isolate',
        colorScheme: 'only light',
        forcedColorAdjust: 'none',
        WebkitAppearance: 'none',
        backgroundImage: 'linear-gradient(#FFFFFF, #FFFFFF)',
      } as unknown as ViewStyle,
      default: {},
    }),
  },
  inner: {
    backgroundColor: '#FFFFFF',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 10,
    alignSelf: 'stretch',
  },
  icon: {
    width: 18,
    height: 18,
  },
  label: {
    color: '#000000',
    fontSize: 14,
    fontWeight: typography.weight.semibold,
  },
});

export default GoogleSignInButton;
